import { render } from "./NotFound.vue?vue&type=template&id=7353f72a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=7353f72a&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353f72a"]])

export default __exports__